angular.module('igs.errorHandlerService', ['igs.messageBox'])
    .factory('igs.errorHandlerService', [
        '$q',
        'igs.messageBox',
        function($q, messageBox) {

            var openErrorMessage = _.throttle(function(error, message) {
                message = getErrorMessage(message, error);

                var errorCode = error.headers("AIOperationId") || null;

                if (errorCode)
                    message += '<br/><br/>ErrorCode: ' + errorCode;
                messageBox.open('Oops!', message || error.data, [{ label: 'OK', cssClass: "btn-primary" }]);

            }, 100, { trailing: false });

            return {
                getErrorHandler: function(message) {
                    return function(error) {
                        openErrorMessage(error, message);

                        return $q.reject(error);
                    };
                }
            };

            function getErrorMessage(message, error) {
                if (message && _.isString(message))
                    return message;
                if (error && _.isString(error))
                    return error;
                if (error && error.data && _.isString(error.data))
                    return error.data;
                if (error && error.data && error.data.exceptionMessage)
                    return error.data.exceptionMessage;
                if (error && error.data && error.data.innerException && error.data.innerException.exceptionMessage && _.isString(error.data.innerException.exceptionMessage))
                    return error.data.innerException.exceptionMessage;
                if (error && error.data && error.data.message && _.isString(error.data.message))
                    return error.data.message;
                return message || (error && error.data);
            }
        }
    ])